import { Component, OnInit, ViewChild } from '@angular/core';
import { ConfigService } from '../../services/config/config.service';
import { DisplayService } from '../../services/display/display.service';
import { DataService } from '../../services/data/data.service';
import { SmartContractService } from '../../services/smart-contract/smart-contract.service';
import { DtvScheduleService } from '../../services/dtv-schedule/dtv-schedule.service';
import { NoteService } from '../../services/note/note.service';
import { CommsService } from '../../services/comms/comms.service';

@Component({
	selector: 'pcm-page-dtv-schedule',
	templateUrl: './page-dtv-schedule.component.html',
	styleUrls: ['./page-dtv-schedule.component.scss']
})
export class PageDtvScheduleComponent implements OnInit {
	@ViewChild('modalForm') modalForm;
	@ViewChild('modalForm') removeTraModal;

	title = 'Delegated Time Verifier Schedule';
	dataObj = this.configService.dtvScheduleDataObj;
	scDataObj = this.configService.dtvScheduleSCDataObj;
	actions = [];
	columnsConfig = [];
	showExportModal = false;
	allowDelete = false;
	showRemoveTRAModal = false;

	jrSteps = [];
	jrStepIDs = [];


	constructor(
		public configService: ConfigService,
		private displayService: DisplayService,
		private dataService: DataService,
		public dtvScheduleService: DtvScheduleService,
		private smartContractService: SmartContractService,
		private noteService: NoteService,
		private commsService: CommsService
		) {
		}

	ngOnInit() {
		this.actions = this.configService.getActions(this.dataObj);
		if (this.actions.length === 0) {
			this.actions.push(this.configService.getExportAction());
		}

		this.columnsConfig = this.configService.getTableFields(this.dataObj, false);
		this.displayService.clearLoading();
		this.dtvScheduleService.selectDefaultTab(this.dtvScheduleService.tabsData.listTabs);
	}

	allowAction = () => {
		return this.dataService.selectedTableRows[0] !== undefined;
	}

	takeAction(event) {
		console.log('TAKE ACTION', event);
		if (event.action.prop === 'exporttocsv') {
			this.showExportModal = true;
		} else if (event.action.prop === 'contractorremovetra') {
			this.showRemoveTRAModal = true;
		} else {
			this.modalForm.showModal(event.action, this.scDataObj, this.dataService.selectedTableRows);
		}
	}

	tableClick(event) {
	}

	tablePage(event) {
	}

	tableSearch(event) {
	}

	tableRefresh(event) {
	}

	tableSelect(event) {
		this.dataService.selectedTableRows = event.selected;
	}

	modalSubmit(event) {
		console.log('MODAL SUBMIT', event);
		this.smartContractService.submitSmartContract(event.data, event.prop, this);
		// this.currentEvent = event.prop;
		const delay = setTimeout(() => {
			this.modalForm.formCancel();
		}, 1000);
	}

	modalDelete(event) {
		console.log('MODAL DELETE', event);
		this.smartContractService.deleteSmartContract(event.data, event.prop, this);
		const self = this;
		const delay = setTimeout(function () {
			self.modalForm.formCancel();
		}, 1000);
	}

	successCall() {
		// this.dataService.clearSelectedTableRows();
		this.dtvScheduleService.loadSchedulesForTab(this.dtvScheduleService.getActiveTab(this.dtvScheduleService.tabsData.listTabs));
		// this.smartContractService.selectDefaultTab(this.smartContractService.tabsData.listTabs);
	}

	errorCall(err) {
		this.noteService.displayError('Failed to update the selected DTV(Delegated Timesheet Verifier) schedule(s)');
		console.log('BULK DTV Schedules ERROR');
	}

	partialCall(res) {
		this.noteService.displayError('Failed to update some or all tthe selected DTV(Delegated Timesheet Verifier) schedule(s)');
		console.log('BULK DTV Schedules PARTIAL');
	}

	closeExportModal() {
		this.showExportModal = false;
	}

	exportToCSV(event) {
	// 	this.commsService.exportToCSV(event.data, this.configService.getTableFields(this.dataObj, false), this.dataService.selectedTableRows);
	// 	const self = this;
	// 	const delay = setTimeout(function () {
	// 		self.closeExportModal();
	// 	}, 1000);
	}

	cancelRemoveTRAModal() {
		this.showRemoveTRAModal = false;
	}

	removeTRA() {
		console.log('Remove TRA');
		const data = {
			contractors: this.dataService.selectedTableRows,
			acltra: '',
			acl: {
				tra: {
					participants: []
				}
			}
		};
		this.cancelRemoveTRAModal();
		this.displayService.startLoading();
		this.commsService.sendContractorDelegation(data).subscribe((res) => {
			console.log('ARCHIVE CONTRACTORS RES: ', res);
			this.noteService.displaySuccess('The Delegated Time Verifiers have been removed successfully.');
			const delay = setTimeout(() => {
				this.dataService.clearSelectedTableRows();
				this.dtvScheduleService.loadSchedulesForTab(this.dtvScheduleService.getActiveTab(this.dtvScheduleService.tabsData.listTabs));
				// console.log('ACTION POST SUCCESS', self.dataService.selectedTableRows);
				this.displayService.endLoading();
			}, 1000);
		}, (err) => {
			this.commsService.handleAPIError('Remove DTV', err);
			const delay = setTimeout(() => {
				// console.log('ACTION POST SUCCESS', self.dataService.selectedTableRows);
				this.dtvScheduleService.loadSchedulesForTab(this.dtvScheduleService.getActiveTab(this.dtvScheduleService.tabsData.listTabs));
				this.displayService.endLoading();
			}, 1000);
		});
	}

}
